'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _range = require('./view/range.js');

var _range2 = _interopRequireDefault(_range);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _range2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-range/lib/index.js
// module id = 219
// module chunks = 0